import React from 'react'

const LogoSmashicons = ({ style = {}, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 98.448 74.462"
      style={style}
      {...props}>
      <defs>
        <style>
          {`.cls-1 { fill: #f81b84; }
          .cls-2 { fill: #fff; }
          .cls-3, .cls-4 { fill: none; stroke: #f5e860; stroke-width: 2px; }
          .cls-3 { stroke-miterlimit: 10; }
          .cls-5 { fill: #43c0f6; }
          .cls-6 { fill: #f5e860; }`}
        </style>
      </defs>
      <g
        id="Group_461"
        data-name="Group 461"
        transform="translate(-1000.5 -548.06)">
        <path
          id="Polygon_3_"
          className="cls-1"
          d="M913.67,543.543a7.346,7.346,0,0,1,6.337,0l28,15.622a6.6,6.6,0,0,1,3.169,5.306v31.17a6.711,6.711,0,0,1-3.169,5.306l-28,15.622a7.346,7.346,0,0,1-6.337,0l-28-15.622a6.6,6.6,0,0,1-3.169-5.306v-31.17a6.711,6.711,0,0,1,3.169-5.306Z"
          transform="translate(132.738 5.235)"
        />
        <path
          id="s_3_"
          className="cls-2"
          d="M937.3,594.033a10.236,10.236,0,0,1-4.2,8.7c-2.8,2.063-6.927,3.169-12.38,3.169a35.017,35.017,0,0,1-5.748-.442,17.08,17.08,0,0,1-4.495-1.326,8.53,8.53,0,0,1-2.948-2.284,5.093,5.093,0,0,1-1.032-3.316,5.312,5.312,0,0,1,.737-2.948,7.77,7.77,0,0,1,1.769-1.99,24.746,24.746,0,0,0,4.863,2.063,20.9,20.9,0,0,0,6.337.884,7.213,7.213,0,0,0,3.463-.663,1.946,1.946,0,0,0,1.179-1.768,1.849,1.849,0,0,0-.884-1.621,8.023,8.023,0,0,0-2.948-.958l-2.211-.442c-4.274-.811-7.443-2.137-9.506-3.906s-3.1-4.348-3.1-7.664a10.182,10.182,0,0,1,1.179-4.937,11.3,11.3,0,0,1,3.316-3.684,16.145,16.145,0,0,1,5.085-2.284,26.2,26.2,0,0,1,6.558-.811,35.812,35.812,0,0,1,5.085.368,18.369,18.369,0,0,1,4.127,1.179,7.505,7.505,0,0,1,2.8,2.063,4.834,4.834,0,0,1,1.032,3.021,6.888,6.888,0,0,1-.589,2.874,7.165,7.165,0,0,1-1.547,1.99,7.046,7.046,0,0,0-1.768-.737,21.556,21.556,0,0,0-2.579-.737c-.958-.221-1.842-.368-2.8-.516a17.388,17.388,0,0,0-2.579-.221,10.211,10.211,0,0,0-3.758.516,1.834,1.834,0,0,0-1.326,1.695,1.562,1.562,0,0,0,.737,1.326,7.926,7.926,0,0,0,2.8.958l2.284.516c4.716,1.105,8.032,2.579,10.022,4.421a10.585,10.585,0,0,1,3.021,7.516Z"
          transform="translate(126.502 -1.336)"
        />
        <ellipse
          id="Oval-465_21_"
          className="cls-3"
          cx="4.2"
          cy="4.127"
          rx="4.2"
          ry="4.127"
          transform="translate(1069.693 557.105)"
        />
        <ellipse
          id="Oval-465_20_"
          className="cls-4"
          cx="3.316"
          cy="3.242"
          rx="3.316"
          ry="3.242"
          transform="translate(1029.681 611.708)"
        />
        <circle
          id="Oval-465_19_"
          className="cls-1"
          cx="1.769"
          cy="1.769"
          r="1.769"
          transform="translate(1020.764 553.494)"
        />
        <circle
          id="Oval-465_18_"
          className="cls-5"
          cx="1.179"
          cy="1.179"
          r="1.179"
          transform="translate(1000.5 567.79)"
        />
        <g id="Group-9_9_" transform="translate(1001.978 587.317)">
          <path
            id="Rectangle-2900_18_"
            className="cls-5"
            d="M868.784,567.6h0a.851.851,0,0,1,.884.884v6.484a.851.851,0,0,1-.884.884h0a.851.851,0,0,1-.884-.884v-6.484A.951.951,0,0,1,868.784,567.6Z"
            transform="translate(-864.658 -567.6)"
          />
          <path
            id="Rectangle-2900_17_"
            className="cls-5"
            d="M863.5,572.984h0a.851.851,0,0,1,.884-.884h6.484a.851.851,0,0,1,.884.884h0a.851.851,0,0,1-.884.884h-6.484A.851.851,0,0,1,863.5,572.984Z"
            transform="translate(-863.5 -568.784)"
          />
        </g>
        <circle
          id="Oval-465_17_"
          className="cls-1"
          cx="1.769"
          cy="1.769"
          r="1.769"
          transform="translate(1067.335 616.424)"
        />
        <circle
          id="Oval-465_16_"
          className="cls-5"
          cx="1.769"
          cy="1.769"
          r="1.769"
          transform="translate(1095.411 592.697)"
        />
        <g id="Group-9_8_" transform="translate(1077.837 602.202)">
          <path
            id="Rectangle-2900_16_"
            className="cls-6"
            d="M964.184,588.8h0a.851.851,0,0,1,.884.884v6.485a.851.851,0,0,1-.884.884h0a.851.851,0,0,1-.884-.884v-6.485A.851.851,0,0,1,964.184,588.8Z"
            transform="translate(-960.058 -588.8)"
          />
          <path
            id="Rectangle-2900_15_"
            className="cls-6"
            d="M958.9,594.084h0a.851.851,0,0,1,.884-.884h6.485a.851.851,0,0,1,.884.884h0a.851.851,0,0,1-.884.884h-6.485A.851.851,0,0,1,958.9,594.084Z"
            transform="translate(-958.9 -589.958)"
          />
        </g>
        <ellipse
          id="Oval-465_15_"
          className="cls-5"
          cx="2.505"
          cy="2.432"
          rx="2.505"
          ry="2.432"
          transform="translate(1093.421 555.484)"
        />
      </g>
    </svg>
  )
}

export default LogoSmashicons
